<template>
  <naj-box :title="local.liquidatorOrJudicialGuardForms.title">
    <v-row>
      <v-col cols="3">
        <naj-input
          :type-id="formFieldType.radioButton"
          :label="local.liquidatorOrJudicialGuardForms.sharedAssetType"
          :value.sync="formModel.sharedAssetType"
          :items="sharedAssetTypes"
          item-value="id"
          item-text="name"
          :validates="`${required ? 'required' : ''}`"
          :tooltip-content="local.liquidatorOrJudicialGuardForms.sharedAssetTypeTooltipContent"
        ></naj-input>
      </v-col>
      <v-col
        v-if="formModel.sharedAssetType === sharedAssetTypeEnum.commonAsset"
        cols="6"
      >
        <naj-input
          :type-id="formFieldType.text"
          :label="local.liquidatorOrJudicialGuardForms.sharedAssetName"
          :value.sync="formModel.name"
          :validates="`${required ? 'required|arabic_letters|isIdAllowed' : ''}`"
        ></naj-input>
      </v-col>
    </v-row>
    <inheritor-type
      v-if="formModel.sharedAssetType === sharedAssetTypeEnum.inheritance"
      :form-model="formModel"
      :required="true"
    ></inheritor-type>
  </naj-box>
</template>
<script>
import { sharedAssetTypeEnum } from '@/helpers/enum';
import { createNamespacedHelpers } from 'vuex';
import InheritorType from '../../party-types/inheritor-type.vue';

const { mapState: mapLUTState } = createNamespacedHelpers('LookupsModule');
export default {
  inject: ['$validator'],
  components: { InheritorType },
  props: ['formModel', 'required'],
  data() {
    return {
      loading: false,
      retrieved: false,
      sharedAssetTypeEnum,
    };
  },
  computed: { ...mapLUTState(['sharedAssetTypes']) },
  watch: {
    'formModel.sharedAssetType'(val) {
      this.clearObject(this.formModel, [
        'sharedAssetType',
        'objectKey',
        'casePartyObjectKey',
        'partyType',
        'casePartyRole',
      ]);
      if (val === 2) {
        this.$set(this.formModel, 'isInheritor', 1);
      }
      else {
        this.$set(this.formModel, 'isInheritor', 0);
      }
    },
  },
  mounted() { },
  methods: {
    resetForm() {
      this.$set(this.formModel, 'name', null);
      this.$set(this.formModel, 'placeAddress', {});
    },
    clearObject(state, exceptArr) {
      for (const key in state) {
        if (Object.prototype.hasOwnProperty.call(state, key) && exceptArr.indexOf(key) === -1) {
          if (typeof state[key] === 'object') {
            this.clearObject(state[key], exceptArr);
          } else {
            state[key] = undefined;
          }
        }
      }
    },
  },

};
</script>

<style scoped>
</style>
